import Parse from "parse";

import type { Bikes_Allowed } from "./Bikes_Allowed";
import type { Calendar } from "./Calendar";
import type { Direction } from "./Direction";
import type { Route } from "./Route";
import type { Wheelchair_Accessible } from "./Wheelchair_Accessible";

type OD3_Tenant = Parse.Object;

export interface TripAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  bikes_allowed?: Bikes_Allowed;
  direction_id?: Direction;
  key: string;
  route_id: Route;
  service_id: Calendar;
  tenant: OD3_Tenant;
  trip_headsign?: string;
  trip_short_name?: string;
  wheelchair_accessible?: Wheelchair_Accessible;
}

export class Trip extends Parse.Object<TripAttributes> {
  static className: string = "OD3_GTFS_Trip";

  constructor(data?: Partial<TripAttributes>) {
    super("OD3_GTFS_Trip", data as TripAttributes);
  }

  get bikes_allowed(): Bikes_Allowed | undefined {
    return super.get("bikes_allowed");
  }
  set bikes_allowed(value: Bikes_Allowed | undefined) {
    super.set("bikes_allowed", value);
  }
  get direction_id(): Direction | undefined {
    return super.get("direction_id");
  }
  set direction_id(value: Direction | undefined) {
    super.set("direction_id", value);
  }
  get route_id(): Route {
    return super.get("route_id");
  }
  set route_id(value: Route) {
    super.set("route_id", value);
  }
  get service_id(): Calendar {
    return super.get("service_id");
  }
  set service_id(value: Calendar) {
    super.set("service_id", value);
  }
  get tenant(): OD3_Tenant {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant) {
    super.set("tenant", value);
  }
  get key(): string | undefined {
    return super.get("key");
  }
  set key(value: string | undefined) {
    super.set("key", value);
  }
  get trip_headsign(): string | undefined {
    return super.get("trip_headsign");
  }
  set trip_headsign(value: string | undefined) {
    super.set("trip_headsign", value);
  }
  get trip_short_name(): string | undefined {
    return super.get("trip_short_name");
  }
  set trip_short_name(value: string | undefined) {
    super.set("trip_short_name", value);
  }
  get wheelchair_accessible(): Wheelchair_Accessible | undefined {
    return super.get("wheelchair_accessible");
  }
  set wheelchair_accessible(value: Wheelchair_Accessible | undefined) {
    super.set("wheelchair_accessible", value);
  }
}

Parse.Object.registerSubclass("OD3_GTFS_Trip", Trip);
